/**
 * Close Modal
 * @description Close Newsletter Modal on click
 */

/**
 * Module Dependencies
 */
var $ = require('jquery'),
    Util = require('./util');

/**
 * Module Vars
 */
var debugEnabled = false,
    debug = debugEnabled ? Util.debug : function() {};

/**
 * Initializes Module
 */
function init() {
    debug('Size Chart');
    showModal();
}

function showModal() {
    
    $( '.size_chart_trigger' ).on( 'click', function() {
        console.log('clicked');
        $( '.modal' ).addClass( 'show' );
        $( '.modal-background' ).addClass( 'show' );
    })
}

/**
 * Module Exports
 */
module.exports = {
    init: init
};